import * as React from "react";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => (
    <span className="inline-grid w-full grid-cols-[1fr_--spacing(8)]">
      <select
        className={cn(
          "col-span-full row-start-1 h-10 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-base text-neutral-950 shadow-xs ring-1 ring-neutral-950/10 outline-none focus-visible:outline-2 -outline-offset-1 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-50 sm:h-9 sm:text-sm",
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none col-start-2 row-start-1 size-4 shrink-0 place-self-center stroke-neutral-500"
      />
    </span>
  )
);

Select.displayName = "Select";
